// extracted by mini-css-extract-plugin
export default {"status":"styles_status__HNzd6","status__title":"styles_status__title__DVXBx","status__check":"styles_status__check__q6Pdp","status__info":"styles_status__info__ecqKY"};